import { Model } from "pinia-orm";

export default class BaseMaterial extends Model {
  static name = "BaseMaterial";
  static primaryKey = "uuid";
  static typeKey = "material_type";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.attr(),
      reference: this.attr(),
      serialNumber: this.attr(),
      agencyUuid: this.attr(),
      brand: this.attr(),
      type: this.attr(),
      businessCategory: this.attr(),
      matrix: this.attr(),
    };
  }
}
